<template>
    <img :src="src" />
</template>
<script>
export default {
    name: "Picture",
    props: ["src"]
};
</script>